import proj4 from 'proj4';
import {register} from 'ol/proj/proj4';

/* EPSG:32633 */
proj4.defs('EPSG:32633', "+proj=utm +zone=33 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ");

/* EPSG:32632 */
proj4.defs('EPSG:32632', "+proj=utm +zone=32 +ellps=WGS84 +datum=WGS84 +units=m +no_defs ");

/* EPSG:3857 */
proj4.defs('EPSG:3857', '+proj=merc +lon_0=0 +k=1 +x_0=0 +y_0=0 +a=6378137 +b=6378137 +towgs84=0,0,0,0,0,0,0 +units=m +no_defs ');

/* EPSG 6706*/
//proj4.defs('EPSG:6706', "+proj=longlat +ellps=GRS80 +towgs84=0,0,0,0,0,0,0 +no_defs");

register(proj4);

export default proj4;